var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin_1_",
    "data-name": "linkedin (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.747,
    height: 18.747,
    viewBox: "0 0 18.747 18.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M20.6,20.4h0V13.528c0-3.363-.724-5.954-4.656-5.954a4.082,4.082,0,0,0-3.677,2.021h-.055V7.888H8.489V20.4h3.882v-6.2c0-1.632.309-3.21,2.33-3.21,1.991,0,2.021,1.862,2.021,3.314V20.4Z",
    transform: "translate(-1.858 -1.658)",
    fill: "#0c61c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M.4,7.977H4.283V20.493H.4Z",
    transform: "translate(-0.087 -1.746)",
    fill: "#0c61c0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M2.251,0A2.262,2.262,0,1,0,4.5,2.251,2.252,2.252,0,0,0,2.251,0Z",
    fill: "#0c61c0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.9291916fa94127a185367053d2de965c.svg";
export { ForwardRef as ReactComponent };